import React from 'react'
import Box from '../box'
import { Skeleton, SxProps } from '@mui/material'

interface LoadingProps {
  sx?: SxProps
}

const Loading: React.FC<LoadingProps> = () => {
  return (
    <Box>
      <Skeleton />
    </Box>
  )
}

export default Loading
